export const SUPPORTED_HLJS_LANGUAGES_ARRAY = [
  '1c',
  'abnf',
  'accesslog',
  'ada',
  'arduino',
  'ino',
  'armasm',
  'arm',
  'avrasm',
  'actionscript',
  'as',
  'angelscript',
  'asc',
  'apache',
  'apacheconf',
  'applescript',
  'osascript',
  'arcade',
  'asciidoc',
  'adoc',
  'aspectj',
  'autohotkey',
  'autoit',
  'awk',
  'mawk',
  'nawk',
  'gawk',
  'bash',
  'sh',
  'zsh',
  'basic',
  'bnf',
  'brainfuck',
  'bf',
  'csharp',
  'cs',
  'c',
  'h',
  'cpp',
  'hpp',
  'cc',
  'hh',
  'c++',
  'h++',
  'cxx',
  'hxx',
  'cal',
  'cos',
  'cls',
  'cmake',
  'cmake.in',
  'coq',
  'csp',
  'css',
  'capnproto',
  'capnp',
  'clojure',
  'clj',
  'coffeescript',
  'coffee',
  'cson',
  'iced',
  'crmsh',
  'crm',
  'pcmk',
  'crystal',
  'cr',
  'd',
  'dart',
  'dpr',
  'dfm',
  'pas',
  'pascal',
  'diff',
  'patch',
  'django',
  'jinja',
  'dns',
  'zone',
  'bind',
  'dockerfile',
  'docker',
  'dos',
  'bat',
  'cmd',
  'dsconfig',
  'dts',
  'dust',
  'dst',
  'ebnf',
  'elixir',
  'elm',
  'erlang',
  'erl',
  'excel',
  'xls',
  'xlsx',
  'fsharp',
  'fs',
  'fsx',
  'fsi',
  'fsscript',
  'fix',
  'fortran',
  'f90',
  'f95',
  'gcode',
  'nc',
  'gams',
  'gms',
  'gauss',
  'gss',
  'gherkin',
  'go',
  'golang',
  'golo',
  'gololang',
  'gradle',
  'graphql',
  'gql',
  'groovy',
  'xml',
  'html',
  'xhtml',
  'rss',
  'atom',
  'xjb',
  'xsd',
  'xsl',
  'plist',
  'svg',
  'http',
  'https',
  'haml',
  'handlebars',
  'hbs',
  'html.hbs',
  'html.handlebars',
  'haskell',
  'hs',
  'haxe',
  'hx',
  'hy',
  'hylang',
  'ini',
  'toml',
  'inform7',
  'i7',
  'irpf90',
  'json',
  'jsonc',
  'java',
  'jsp',
  'javascript',
  'js',
  'jsx',
  'julia',
  'jl',
  'julia-repl',
  'kotlin',
  'kt',
  'tex',
  'leaf',
  'lasso',
  'ls',
  'lassoscript',
  'less',
  'ldif',
  'lisp',
  'livecodeserver',
  'livescript',
  'ls',
  'lua',
  'makefile',
  'mk',
  'mak',
  'make',
  'markdown',
  'md',
  'mkdown',
  'mkd',
  'mathematica',
  'mma',
  'wl',
  'matlab',
  'maxima',
  'mel',
  'mercury',
  'mips',
  'mipsasm',
  'mizar',
  'mojolicious',
  'monkey',
  'moonscript',
  'moon',
  'n1ql',
  'nsis',
  'nginx',
  'nginxconf',
  'nim',
  'nimrod',
  'nix',
  'ocaml',
  'ml',
  'objectivec',
  'mm',
  'objc',
  'obj-c',
  'obj-c++',
  'objective-c++',
  'glsl',
  'openscad',
  'scad',
  'ruleslanguage',
  'oxygene',
  'pf',
  'pf.conf',
  'php',
  'parser3',
  'perl',
  'pl',
  'pm',
  'plaintext',
  'txt',
  'text',
  'pony',
  'pgsql',
  'postgres',
  'postgresql',
  'powershell',
  'ps',
  'ps1',
  'processing',
  'prolog',
  'properties',
  'proto',
  'protobuf',
  'puppet',
  'pp',
  'python',
  'py',
  'gyp',
  'profile',
  'python-repl',
  'pycon',
  'k',
  'kdb',
  'qml',
  'r',
  'reasonml',
  're',
  'rib',
  'rsl',
  'graph',
  'instances',
  'ruby',
  'rb',
  'gemspec',
  'podspec',
  'thor',
  'irb',
  'rust',
  'rs',
  'SAS',
  'sas',
  'scss',
  'sql',
  'p21',
  'step',
  'stp',
  'scala',
  'scheme',
  'scilab',
  'sci',
  'shell',
  'console',
  'smali',
  'smalltalk',
  'st',
  'sml',
  'ml',
  'stan',
  'stanfuncs',
  'stata',
  'stylus',
  'styl',
  'subunit',
  'swift',
  'tcl',
  'tk',
  'tap',
  'thrift',
  'tp',
  'twig',
  'craftcms',
  'typescript',
  'ts',
  'tsx',
  'mts',
  'cts',
  'vbnet',
  'vb',
  'vbscript',
  'vbs',
  'vhdl',
  'vala',
  'verilog',
  'v',
  'vim',
  'axapta',
  'x++',
  'x86asm',
  'xl',
  'tao',
  'xquery',
  'xpath',
  'xq',
  'xqm',
  'yml',
  'yaml',
  'zephir',
  'zep',
] as const
